import { useTranslation } from "@hireroo/i18n";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ListItem, { type ListItemProps } from "@mui/material/ListItem";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import * as React from "react";

import DeleteDialog, { DeleteDialogProps } from "../../../../modules/DeleteDialog/DeleteDialog";
import IconButtonWithTooltip, { IconButtonWithTooltipProps } from "../../../../primitive/Button/IconButtonWithTooltip/IconButtonWithTooltip";

export type TagFieldListItemProps = {
  valueId: string;
  deleteDialogProps: DeleteDialogProps;
  deleteButton: Pick<IconButtonWithTooltipProps, "onClick">;
  onClick?: ListItemProps["onClick"];
} & React.HTMLAttributes<HTMLLIElement>;

const TagFieldListItem: React.FC<TagFieldListItemProps> = props => {
  const { t } = useTranslation();
  const theme = useTheme();

  const { valueId, deleteDialogProps, deleteButton: deleteButtonProps, ...otherProps } = props;

  const deleteButton: IconButtonWithTooltipProps = {
    sx: {
      width: "26px",
      height: "26px",
    },
    onClick: event => {
      event.stopPropagation();
      deleteButtonProps.onClick?.(event);
    },
    title: t("削除"),
    children: <DeleteOutlineIcon fontSize="small" htmlColor={theme.palette.text.secondary} />,
  };

  return (
    <ListItem
      {...otherProps}
      disablePadding
      secondaryAction={<IconButtonWithTooltip disabled={false} key="delete-button" {...deleteButton} edge="end" />}
    >
      <Stack direction="row" justifyContent="space-between" width="100%">
        <Stack direction="row" alignItems="center" gap={1}>
          <Typography>{valueId}</Typography>
        </Stack>
      </Stack>
      <DeleteDialog {...deleteDialogProps} />
    </ListItem>
  );
};

TagFieldListItem.displayName = "TagFieldListItem";

export default TagFieldListItem;
